<template>
  <div class="max-w-114">
    <div class="flex justify-between items-center">
      <p>
        <span class="font-sans font-medium mr-2 capitalize" :class="`text-member-${memberColour}`">{{
          memberColour
        }}</span>
        <span>{{ timeSpan }}</span>
      </p>
      <p v-if="nextLevel" class="text-lighter text-xs">
        <strong>Next level</strong> <span class="capitalize">{{ nextLevel }}</span>
      </p>
    </div>
    <progress
      max="100"
      :value="value"
      class="rounded-full h-2 w-full"
      :class="`[&::-moz-progress-bar]:bg-progress-${memberColour}-member [&::-webkit-progress-value]:bg-progress-${memberColour}-member`"
    ></progress>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  value: number;
  memberColour: string;
  memberSince?: Date;
  nextLevel: string;
}>();

const daysAsMember = props.memberSince
  ? Math.round((Date.now() - props.memberSince.getTime()) / (1000 * 60 * 60 * 24))
  : null;
const yearsAsMember = props.memberSince && daysAsMember ? Math.floor(daysAsMember / 365) : 0;
const timeSpan =
  !props.memberSince || yearsAsMember == null || !daysAsMember
    ? '1 day' /** special case for first day member before 10am */
    : yearsAsMember > 0
      ? `${yearsAsMember} year${yearsAsMember > 1 ? 's' : ''}`
      : `${daysAsMember} day${daysAsMember > 1 || daysAsMember == 0 ? 's' : ''}`;
</script>
